import { message } from 'antd'
import { GroupsApi } from '../../../api/Groups'
import { TaskSystemApi } from '../../../api/TaskSystem'
import { TaskTagsColor } from '../../../components/Operations/TaskSystem/List'
import TaskSystem from '../../../components/Operations/TaskSystem/TaskSystem'
import useListFilter from '../../../elements/Hooks/useListFilter'
import Authentication from '../../../modules/Authentication'
import { strVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useTitle from '../../../elements/Hooks/useTitle'
import _ from 'lodash'

function TaskSystemCont(props) {
  const auth = new Authentication()
  const { list: cached, fetching, fetch } = useFetchList(() => TaskSystemApi.list())

  const { list: groupsList } = useFetchList(() => GroupsApi.links.list())
  const [group, setGroup] = useState(undefined)

  const { list, company: employee, onChangeCompany, setList, setCompany } = useListFilter(cached, fetching, [
    'created.name',
    'assignedTo',
  ])

  function onChangeCompanyCard(user) {
    let filtered = cached.filter((row) => {
      const createdBy = _.get(row, 'created.name._id')
      const createdFor = _.get(row, 'assignedTo._id')
      const group = _.get(row, 'group._id')
      const groupuser = groupsList.filter((gl) => gl._to === group && gl._from === user)
      return createdBy === user || createdFor === user || (_.isEmpty(row.assignedTo) && !_.isEmpty(groupuser))
    })
    if (user) {
      setList(filtered)
      setCompany(user)
    } else {
      setList(cached)
      setCompany(undefined)
    }
  }

  function onChangeGroupCard(group) {
    let filtered = cached.filter((row) => _.get(row, 'group._id') === group)
    if (group) {
      setList(filtered)
      setGroup(group)
    } else {
      setList(cached)
      setGroup(undefined)
    }
  }

  useEffect(() => {
    const userId = auth.getMember()._id
    //onChangeCompanyCard(userId)
  }, [fetching])

  const [listView, setListView] = useState(false)

  function changeView() {
    setListView(!listView)
  }

  function getCards(filterState) {
    let cards = list.filter((t) => (t.state ? t.state === filterState : false))
    if (_.isEmpty(cards)) return []

    return cards.map((task) => {
      const { _id, type, title, description, due, tag } = task
      const CardDescription = type.toUpperCase() + ': ' + title

      return {
        id: _id,
        //title: title.length > 15 ? `${title.substring(0, 15)}...` : task.title,
        title: CardDescription,
        description: description,
        label: due && `Due ${moment(due.date).fromNow()}`,
        tags:
          tag &&
          tag.map((t) => ({
            title: t,
            color: 'white',
            bgcolor: TaskTagsColor[t] || '108ee9',
          })),
      }
    })
  }

  function onClickCard(id) {
    const key = id.replace('task/', '')
    props.history.push({
      pathname: `/operations/task-system/${key}/update`,
    })
  }

  async function onChangeCard(cardId, targetLaneId, sourceLaneId) {
    console.log({ cardId, targetLaneId, sourceLaneId })
    try {
      await TaskSystemApi.changeState({ _id: cardId, state: sourceLaneId })
    } catch (e) {
      console.error(e)
      fetch()
      message.error(e.errorMessage || 'Use Fetch List Not Found')
    }
    console.log('done')
  }

  function onFilteredChangeCard(period, accsessor, type) {
    console.log('onFilteredChangeCard')

    if (type === 'all') {
      setList(cached)
      return
    }

    const [start, end] = period
    let filtered = cached
      .map((a) => a)
      .filter((row) => {
        const due = moment(row.due.date)
        return due.isBetween(start, end)
      })
    setList(filtered)
  }

  function handleOnSearch(e) {
    let filtered = cached
      .map((a) => a)
      .filter((row) => {
        return (
          strVal(row, 'code').toUpperCase().includes(e.target.value.toUpperCase()) ||
          strVal(row, 'description').toUpperCase().includes(e.target.value.toUpperCase()) ||
          strVal(row, 'title').toUpperCase().includes(e.target.value.toUpperCase())
        )
      })
    setList(filtered)
  }

  useTitle('Task System')
  const data = {
    lanes: [
      {
        id: 'BackLog',
        title: 'BackLog Tasks',
        cards: getCards('BackLog'),
        style: { backgroundColor: '#f2f2f2' },
      },
      {
        id: 'Todo',
        title: 'Todo',
        cards: getCards('Todo'),
        style: { backgroundColor: 'rgb(240, 173, 78)' },
      },
      {
        id: 'Doing',
        title: 'Doing',
        cards: getCards('Doing'),
        style: { backgroundColor: 'rgb(92, 184, 92)' },
      },
      {
        id: 'Done',
        title: 'Done',
        cards: getCards('Done'),
        style: { color: '#FFF', backgroundColor: '#000' },
      },
    ],
  }
  return (
    <TaskSystem
      {...{
        list,
        fetching,
        fetch,
        employee,
        onChangeCompany,
        listView,
        data,
        changeView,
        //customCard,
        onClickCard,
        onChangeCard,
        onChangeCompanyCard,
        onFilteredChangeCard,
        handleOnSearch,
        onChangeGroupCard,
        group,
      }}
    />
  )
}

TaskSystemCont.propTypes = {}
TaskSystemCont.defaultProps = {}

export default TaskSystemCont
